module.exports = __webpack_public_path__ + "static/media/Varp-M.b32b4d38.jpg";